import { validatorRequire, validatorRequireNumber } from '@/utils/validators';
import Select from '@/components/DSE/Select';

export function getFormDefinition(vue) {
  return {
    priceListItemID: {
      type: Select,
      props: {
        caption: 'domain.deliveryPrice',
        valueField: 'id',
        labelField: 'description',
        loading: vue.$store.getters['priceListItem/isLoading'],
        options: vue.$store.getters['priceListItem/loadedItems'],
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    countryID: {
      type: Select,
      props: {
        caption: 'common.country',
        valueField: 'id',
        labelField: 'name',
        loading: vue.$store.getters['country/isLoading'],
        options: vue.$store.getters['country/loadedItems'],
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    deliveryPriceType: {
      type: Select,
      props: {
        caption: 'common.type',
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('deliveryPrice'),
        required: true
      },
      rules: [{ validator: validatorRequireNumber }]
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  const form = {
    ...item
  };
  return form;
}
